import 'jquery';
import 'bootstrap';
// var $ = jQuery = require('jquery')(window);
jQuery(document).ready(function($) {
    $("a[data-lightbox='product-gallery']").fancybox();

    // Mobile menu toggle
    var $mobileMenu = $('#mobile-menu');
    var $triggerBtn = $('#trigger-mobile-menu');
    var $closeBtn = $('#close-mobile-menu');

    $triggerBtn.on('click', function(e) {
        e.preventDefault();
        $mobileMenu.addClass('is-open');
        $('body').addClass('menu-open');
    });

    $closeBtn.on('click', function(e) {
        e.preventDefault();
        $mobileMenu.removeClass('is-open');
        $('body').removeClass('menu-open');
    });

    // Close menu on overlay click
    $mobileMenu.on('click', function(e) {
        if (e.target === this) {
            $mobileMenu.removeClass('is-open');
            $('body').removeClass('menu-open');
        }
    });
});